import { reactive } from "vue";

let idCounter = 0;

const state = reactive({
  items: [],
});

const TYPE_CONFIG = {
  success: { icon: "mdi-check" },
  error: { icon: "mdi-close" },
  info: { icon: "mdi-information-outline" },
  warning: { icon: "mdi-alert-outline" },
  default: { icon: "mdi-bell-outline" },
};

function normalizeType(type) {
  if (!type) return "default";
  const normalized = String(type).toLowerCase();
  if (normalized === "green") return "success";
  if (normalized === "red") return "error";
  if (normalized === "blue") return "info";
  if (normalized === "orange" || normalized === "amber") return "warning";
  if (TYPE_CONFIG[normalized]) return normalized;
  return "default";
}

export function showSnackbar({
  type = "default",
  title,
  message = "",
  duration = 4500,
} = {}) {
  const id = ++idCounter;
  const normalizedType = normalizeType(type);
  const item = {
    id,
    type: normalizedType,
    title: title || message || "Notification",
    message: title ? message : "",
    icon: TYPE_CONFIG[normalizedType].icon,
  };

  state.items.push(item);

  if (duration > 0) {
    setTimeout(() => dismissSnackbar(id), duration);
  }

  return id;
}

export function dismissSnackbar(id) {
  const index = state.items.findIndex((item) => item.id === id);
  if (index !== -1) {
    state.items.splice(index, 1);
  }
}

export function clearSnackbars() {
  state.items.splice(0, state.items.length);
}

export function useSnackbarState() {
  return state;
}
